import { DropDownItem } from "../../../pojo/DropDownItem";

export interface WorkflowCustAtrbMappingRow {
    custAtrbId: number | undefined;
    valueRef: string;
}

export interface WorkflowCustAtrbMappingUiRow extends WorkflowCustAtrbMappingRow {
    rowKey: string;
    dropdownChoice?: DropDownItem | null;
}

let nextWorkflowCustAtrbRowKey = 0;

function newWorkflowCustAtrbRowKey(): string {
    nextWorkflowCustAtrbRowKey += 1;
    return `workflow-ca-row-${nextWorkflowCustAtrbRowKey}`;
}

export function createEmptyWorkflowCustAtrbMappingRow(): WorkflowCustAtrbMappingUiRow {
    return { rowKey: newWorkflowCustAtrbRowKey(), custAtrbId: undefined, valueRef: "" };
}

export function parseWorkflowCustAtrbMappings(raw: string | undefined): WorkflowCustAtrbMappingUiRow[] {
    if (!raw?.trim()) {
        return [];
    }
    try {
        const parsed = JSON.parse(raw) as unknown;
        if (!Array.isArray(parsed)) {
            return [];
        }
        return parsed.map((entry) => {
            const custAtrbId = entry?.custAtrbId;
            return {
                rowKey: newWorkflowCustAtrbRowKey(),
                custAtrbId,
                valueRef: entry?.valueRef ?? "",
                dropdownChoice: dropdownItemFromCustAtrbId(custAtrbId),
            };
        });
    } catch {
        return [];
    }
}

export function serializeWorkflowCustAtrbMappings(rows: WorkflowCustAtrbMappingUiRow[]): string {
    const complete = rows
        .filter((row) => row.custAtrbId != null && row.valueRef?.trim())
        .map((row) => ({ custAtrbId: row.custAtrbId, valueRef: row.valueRef }));
    return complete.length ? JSON.stringify(complete) : "";
}

export function dropdownItemFromCustAtrbId(id: number | undefined): DropDownItem | undefined {
    if (id == null || !Number.isFinite(id)) {
        return undefined;
    }
    return { itemId: id, val: id };
}

export function custAtrbIdFromDropdownItem(choice: DropDownItem | null | undefined): number | undefined {
    if (!choice || choice.isNoneItem) {
        return undefined;
    }
    const raw = choice.itemId ?? choice.val;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : undefined;
}
